$(window).on('load', function() {
   var $container = $('.archive-container').masonry({
        itemSelector: "img",
        columnWidth: ".grid-sizer",
     gutter: ".gutter-sizer",
     percentPosition: true      
    });

   $container.imagesLoaded().progress( function() {
        $container.masonry('layout');
   });
      
});

$(document).ready(function() {
 $("img").each(function() {
    var item = $(this); 
    var image = item.attr('src');
    $(item).attr('data-featherlight', image);
 });

  const title = $('.archive-title').attr('data-title');
  if (title) {
      const year = title.split('-')[0];
      const name = title.split('-')[1];
      $('.archive-year').text(year);
      $('.archive-name').text(name);
    if ($('.archive-year:empty').length < 1) {
      $('.archive-year').removeClass("visually-hidden");
    }
    if ($('.archive-name:empty').length < 1) {
      $('.archive-name').removeClass("visually-hidden");
    }
  }
});

$('.year-toggle').click(function(){
  var dropDownList = $(this).parent();
  $(this).parent().find('ul').slideToggle().find('li').click(function(){
    var v = $(this).attr('data-year');
    var t = $(this).text();
     $(this).siblings().removeClass('selected-active');
    $(this).addClass('selected-active');

    dropDownList.find('input').attr('value', v);
    dropDownList.find('span').text(t);
    dropDownList.find('span').attr('data-val', v);

      const names = $(".archive-name-wrapper");
      let activeNames;
      let activeArchives;
      names.each(function(){
          if ($(this).attr('data-year')  ===  v) {
            $(this).addClass('active');
            activeNames = $(".archive-name-wrapper.active");
            const name = activeNames[0].innerText;
            $('.archive-toggle').text(name);
            $('.archive-toggle').attr('data-name', name.toLowerCase().replace(/ /g, ''));

            if ($(this).context.innerText.toLowerCase().replace(/ /g, '') === name.toLowerCase().replace(/ /g, '')) {
              $(this).addClass('selected-active');
              $(this).siblings().removeClass('selected-active');
            } 
          } else {
            $(this).removeClass('active');
          }
      });

      let archives = $('.archive');
        archives.each(function(){
          const activeName = $('.archive-toggle')[0].innerText.toLowerCase().replace(/ /g, '');
          const name = $(this).attr('data-name').toLowerCase().replace(/ /g, '');

          if (activeName === name) {
            $(this).addClass('active');
            $(this).siblings().removeClass('.active');

            var $container = $(this).find('.archive-container').masonry({
                itemSelector: "img",
                columnWidth: ".grid-sizer",
             gutter: ".gutter-sizer",
             percentPosition: true      
            });
            $container.masonry('layout');
          } else {
            $(this).removeClass('active');
          }
      });
  });
});

$('.archive-toggle').click(function(){
    var dropDownList = $(this).parent();
  $(this).parent().find('ul').slideToggle().find('li').click(function(){
    var v = $(this).attr('data-id');
    var y = $(this).attr('data-year');
    var t = $(this).attr('data-name');

     $(this).siblings().removeClass('selected-active');
    $(this).addClass('selected-active');

    dropDownList.find('input').attr('value', v);
    dropDownList.find('span').attr('data-val', v);
    dropDownList.find('span').text(t); 
    
      const years = $(".archive-year");
      const archives = $('.archive');
      let activeYears;
      let activeArchives;

    years.each(function(){
          if ($(this).attr('data-year')  === y) {
            $(this).addClass('active');
            $(this).siblings().removeClass('.active');

            $('.year-toggle').text(y);
          } else {
            $(this).removeClass('active');
          }
      });

        archives.each(function(){
          if ($(this).attr('data-id')  === v) {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');

            var $container = $(this).find('.archive-container').masonry({
                itemSelector: "img",
                columnWidth: ".grid-sizer",
             gutter: ".gutter-sizer",
             percentPosition: true      
            });
            $container.masonry('layout');
          } else {
            $(this).removeClass('active');
          }
      });
    });
});

// close the list when click out..
$(document).mouseup(function(e){ 
    var container = $(".dropdown-toggle");
    if (!container.is(e.target)
        && container.has(e.target).length === 0){
        container.parent().find('ul').slideUp();
    }
});